import { render } from "./ReportSalesWeb.vue?vue&type=template&id=cbcb8888&scoped=true"
import script from "./ReportSalesWeb.vue?vue&type=script&lang=js"
export * from "./ReportSalesWeb.vue?vue&type=script&lang=js"

import "./ReportSalesWeb.vue?vue&type=style&index=0&id=cbcb8888&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbcb8888"]])

export default __exports__